export const resetPortfolioFilters = () => {
	const mobileFilters = document.querySelectorAll('.portfolio__header--filter-mobile button');
	const primaryFilters = document.querySelectorAll('.portfolio__header--filters button');
	mobileFilters.forEach((el) => el.classList.remove('active'));
	primaryFilters.forEach((el) => el.classList.remove('active'));
};

export const resetInsightFilters = () => {
	const mobileFilters = document.querySelectorAll('.insight__header--filter-mobile button');
	const primaryFilters = document.querySelectorAll('.insight__header--filters button');
	mobileFilters.forEach((el) => el.classList.remove('active'));
	primaryFilters.forEach((el) => el.classList.remove('active'));
};
